import useSWR from 'swr';
import { DGetCustomerContact } from '../data/dtos/contact';
import { marketplaceChatService } from '../services/marketplace';

export function useMarketplaceCustomerContact({
  userId,
  conversationId,
}: Nullable<DGetCustomerContact>) {
  const execute = async () => {
    return await marketplaceChatService.getCustomerContact({
      userId: userId!,
      conversationId: conversationId!,
    });
  };

  const fetchKey =
    userId && conversationId
      ? ['get-marketplace-customer-contact', userId, conversationId]
      : null;
  const { data, error, isLoading } = useSWR(fetchKey, execute);

  return {
    data,
    error,
    isLoading,
  };
}
